(function () {
  const values = item => item.color !== undefined ? [item.color, item.length, item.packs] : item.options_with_values?.map(value => value.value) || item.variant_options || item.options || [];
  const variantId = item => Number(item.variant_id || item.id);
  const groupKey = item => JSON.stringify([String(item.product_id), String(values(item)[0]), String(values(item)[1])]);
  const plain = item => item.plain !== false && !Object.keys(item.properties || {}).length && !item.selling_plan_allocation && !item.parent_relationship && item.instructions?.can_remove !== false && item.instructions?.can_update_quantity !== false;
  const snapshot = items => JSON.stringify(items.map(item => [variantId(item), item.quantity, Object.entries(item.properties || {}).sort()]).sort((a, b) => a[0] - b[0]));
  const groupItems = (cart, key) => cart.items.filter(item => groupKey(item) === key && plain(item));
  const validCount = count => Number.isInteger(Number(count)) && Number(count) > 0 && Number(count) <= 999;
  class PackError extends Error { constructor(code) { super(code); this.code = code; } }
  async function replaceGroup({ api, key, targetId, expected }) {
    const before = await api.cart();
    const original = groupItems(before, key);
    if (expected !== undefined && snapshot(original) !== expected) throw new PackError('changed');
    if (before.items.some(item => groupKey(item) === key && !plain(item))) throw new PackError('changed');
    if (new Set(original.map(variantId)).size !== original.length) throw new PackError('changed');
    const wantedId = Number(targetId);
    if (!Number.isSafeInteger(wantedId) || wantedId < 0) throw new PackError('changed');
    const targetBefore = original.find(item => variantId(item) === wantedId);
    if (wantedId && original.length === 1 && targetBefore?.quantity === 1) return before;
    const untouched = cart => snapshot(cart.items.filter(item => groupKey(item) !== key)) === snapshot(before.items.filter(item => groupKey(item) !== key));
    const originalIntact = cart => snapshot(groupItems(cart, key).filter(item => variantId(item) !== wantedId)) === snapshot(original.filter(item => variantId(item) !== wantedId)) && untouched(cart);
    let working = before, added = false;
    async function readback() { try { return await api.cart(); } catch { throw new PackError('error'); } }
    async function revertAddition(cart) {
      const targets = groupItems(cart, key).filter(item => variantId(item) === wantedId);
      if (!added || !originalIntact(cart) || targets.length !== 1 || targets[0].quantity !== 1) return false;
      try { await api.change(targets[0].key, 0); } catch {}
      return snapshot((await readback()).items) === snapshot(before.items);
    }
    if (wantedId && !targetBefore) {
      let accepted = false;
      try { await api.add(wantedId, 1); accepted = true; } catch {}
      working = await readback();
      const targets = groupItems(working, key).filter(item => variantId(item) === wantedId);
      added = targets.length === 1 && targets[0].quantity === 1;
      if (!accepted || !added || !originalIntact(working)) {
        if (snapshot(working.items) === snapshot(before.items)) throw new PackError('unavailable');
        await revertAddition(working);
        throw new PackError('error');
      }
    }
    const updates = {};
    groupItems(working, key).forEach(item => { updates[item.key] = wantedId && variantId(item) === wantedId ? 1 : 0; });
    if (!Object.keys(updates).length) return working;
    try { await api.update(updates); } catch {}
    const after = await readback();
    const remaining = groupItems(after, key);
    const correct = wantedId ? remaining.length === 1 && variantId(remaining[0]) === wantedId && remaining[0].quantity === 1 : remaining.length === 0;
    if (correct && untouched(after)) return after;
    await revertAddition(after);
    throw new PackError('error');
  }
  const core = { values, variantId, groupKey, plain, snapshot, groupItems, validCount, replaceGroup, PackError };
  if (typeof module === 'object' && module.exports) module.exports = core;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  window.TFTotalPacks = core;
  const node = document.getElementById('tf-total-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  config.root = String(config.root || '/').replace(/\/?$/, '/');
  const decode = value => { const el = document.createElement('textarea'); el.innerHTML = String(value); return el.value; };
  Object.keys(config.strings).forEach(key => { config.strings[key] = decode(config.strings[key]); });
  const text = config.strings, cap = Number(config.cap), pending = new Map(), products = new WeakMap();
  let busy = false, scheduled = false;
  const fmt = (key, replacements = {}) => String(text[key] || key).replace(/\[(\w+)\]/g, (_, key) => String(replacements[key] ?? ''));
  const esc = value => String(value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const packText = count => `${count} ${count === 1 ? text.packs_one : text.packs_many}`;
  function domCart() {
    const source = document.querySelector('cart-drawer [data-tp-cart]') || document.querySelector('cart-items [data-tp-cart]');
    try { return JSON.parse(source?.textContent || '{"items":[]}'); } catch { return { items: [] }; }
  }
  function selections(cart, override) {
    const groups = new Map();
    for (const item of cart.items) {
      const options = values(item), count = parseFloat(options[2]) * item.quantity;
      if (!validCount(count)) continue;
      const key = groupKey(item), current = groups.get(key);
      if (current) current.count += count;
      else groups.set(key, { product: item.handle, color: options[0], length: options[1], count });
    }
    for (const [key, value] of pending) if (groups.has(key)) groups.get(key).count = value;
    if (override) groups.set(override.key, override.item);
    return [...groups.values()];
  }
  function route(cart = domCart(), override) {
    const items = selections(cart, override), total = items.reduce((sum, item) => sum + (validCount(item.count) ? Number(item.count) : 0), 0);
    const bad = [...pending.values()].some(value => !validCount(value));
    return { items, total, quote: total > cap || cap === 0 || cart.items.some(item => item.available === false) || bad, invalid: bad };
  }
  function quoteUrl(items) {
    const url = new URL(config.quoteUrl, location.origin);
    url.hash = new URLSearchParams({ request: JSON.stringify({ country: config.country, purpose: 'personal', items }) }).toString();
    return url.href;
  }
  async function request(path, body) {
    const response = await fetch(config.root + path, body === undefined ? { cache: 'no-store' } : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await response.json();
    if (!response.ok || data.status >= 400 || data.errors) throw new Error('request_failed');
    return data;
  }
  const api = { cart: () => request('cart.js'), add: (id, quantity) => request('cart/add.js', { items: [{ id, quantity }] }), update: updates => request('cart/update.js', { updates }), change: (id, quantity) => request('cart/change.js', { id, quantity }) };
  function updateFooters() {
    const decision = route();
    document.querySelectorAll('#CartDrawer-Checkout,button[name="checkout"][form="cart"],#checkout').forEach(button => {
      const footer = button.closest('.drawer__footer') || button.closest('.cart-drawer__footer') || button.closest('#main-cart-footer');
      if (!footer) return;
      if (!button.dataset.tpLabel) button.dataset.tpLabel = button.textContent.trim();
      footer.classList.toggle('tf-total-quote', decision.quote);
      let panel = footer.querySelector('.tp-total-route');
      if (!panel) { panel = document.createElement('div'); panel.className = 'tp-total-route'; panel.setAttribute('role', 'status'); button.parentElement.before(panel); }
      const html = `<strong>${esc(text.quote_title)}</strong>${esc(text.quote_body)}<p>${esc(fmt('requested', { count: decision.total, grams: decision.total * 100 }))}</p><p>${esc(text.pending)}</p>`;
      if (panel.innerHTML !== html) panel.innerHTML = html;
      panel.hidden = !decision.quote || !decision.items.length;
      const label = decision.quote ? text.quote_bag : button.dataset.tpLabel;
      if (button.textContent !== label) button.textContent = label;
      const disabled = busy || !domCart().items.length || decision.invalid;
      if (button.disabled !== disabled) button.disabled = disabled;
    });
  }
  function selectedProduct(info) {
    let variant = null;
    try { variant = JSON.parse(info.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch {}
    const color = info.querySelector('.native-color-card input:checked')?.value || variant?.options?.[0];
    const length = info.querySelector('.native-length-field select')?.value || variant?.options?.[1];
    const picker = info.querySelector('variant-selects');
    const selected = { product: picker?.dataset.productHandle, color, length, count: parseFloat(variant?.options?.[2] || info.querySelector('.native-pack-field input:checked')?.value) };
    return { variant, item: selected, key: JSON.stringify([String(info.dataset.productId), String(color), String(length)]) };
  }
  function productState(info) {
    if (!products.has(info)) products.set(info, { more: false });
    return products.get(info);
  }
  function renderProduct(info) {
    const state = productState(info), selected = selectedProduct(info), input = info.querySelector('[data-total-more-count]');
    if (!selected.item.product) return;
    const automaticallyMore = selected.item.count > cap || cap === 0;
    if (automaticallyMore) state.more = true;
    const more = state.more || automaticallyMore;
    const count = more ? Number(input?.value || Math.max(cap + 1, selected.item.count || 1)) : selected.item.count;
    const valid = validCount(count) && (!more || count > cap);
    const item = { ...selected.item, count };
    const decision = route(domCart(), { key: selected.key, item });
    const quote = more || decision.quote;
    const existing = domCart().items.filter(line => groupKey(line) === selected.key).reduce((sum, line) => sum + parseFloat(values(line)[2]) * line.quantity, 0);
    info.style.setProperty('--tp-cols', String(Math.max(1, cap + 1)));
    info.classList.toggle('tp-more-active', more);
    info.querySelector('[data-total-more]')?.setAttribute('aria-pressed', String(more));
    const panel = info.querySelector('[data-total-more-panel]'); if (panel) panel.hidden = !more;
    const summary = info.querySelector('[data-total-selection]');
    const label = valid ? `${packText(count)} · ${count * Number(info.dataset.totalGrams)}g` : fmt('invalid', { min: cap + 1 });
    if (summary && summary.textContent !== label) summary.textContent = label;
    const hint = info.querySelector('[data-total-existing]');
    if (hint) { hint.hidden = !existing; const value = fmt('existing', { count: existing }); if (hint.textContent !== value) hint.textContent = value; }
    const button = info.querySelector('product-form button[name="add"]');
    if (button) {
      const value = valid ? fmt(quote ? 'quote_selection' : existing ? 'update' : 'add', { count }) : fmt('invalid', { min: cap + 1 });
      const target = button.querySelector('span') || button;
      if ((quote || !button.disabled) && target.textContent !== value) target.textContent = value;
      if (quote && !busy && button.disabled === valid) button.disabled = !valid;
      if (busy && !button.disabled) button.disabled = true;
    }
    const mobile = info.querySelector('[data-native-mobile-buy]');
    if (mobile) { if (!mobile.dataset.tpLabel) mobile.dataset.tpLabel = mobile.textContent; const label = quote ? text.quote : fmt(existing ? 'update' : 'add', { count }); if (mobile.textContent !== label) mobile.textContent = label; }
    info.querySelectorAll('[data-native-total]').forEach(el => { if (more) { if (!el.dataset.tpPrice) el.dataset.tpPrice = el.textContent; if (el.textContent !== text.quote_price) el.textContent = text.quote_price; } else if (el.textContent === text.quote_price && el.dataset.tpPrice) el.textContent = el.dataset.tpPrice; else el.dataset.tpPrice = el.textContent; });
    const quoteLink = info.querySelector('[data-total-quote]');
    if (quoteLink) { const href = quoteUrl(decision.items); if (quoteLink.href !== href) quoteLink.href = href; }
  }
  function renderAll() {
    document.querySelectorAll('[data-total-product]').forEach(renderProduct);
    updateFooters();
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true; queueMicrotask(() => { scheduled = false; renderAll(); });
  }
  async function refresh(cart, message) {
    const main = document.querySelector('#main-cart-items')?.dataset.id, footer = document.querySelector('#main-cart-footer')?.dataset.id;
    const sections = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', main, footer].filter(Boolean);
    const url = new URL(config.root + 'cart', location.origin); url.searchParams.set('sections', sections.join(','));
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error('refresh_failed');
    const data = await response.json();
    const replace = (target, html, selector) => {
      if (!target) return;
      const source = new DOMParser().parseFromString(html || '', 'text/html').querySelector(selector);
      if (!source) throw new Error('section_missing');
      target.innerHTML = source.innerHTML;
    };
    replace(document.querySelector('cart-drawer #CartDrawer'), data['cart-drawer'], '#CartDrawer');
    replace(document.querySelector('#cart-icon-bubble'), data['cart-icon-bubble'], '.shopify-section');
    if (main) replace(document.querySelector('cart-items'), data[main], 'cart-items');
    if (footer) replace(document.getElementById('main-cart-footer'), data[footer], '#main-cart-footer');
    const drawer = document.querySelector('cart-drawer');
    drawer?.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
    if (cart) {
      drawer?.classList.toggle('is-empty', !cart.items.length);
      document.querySelector('cart-items')?.classList.toggle('is-empty', !cart.items.length);
    }
    const target = document.querySelector('cart-drawer.active .drawer__inner') || document.querySelector('cart-items');
    if (target && message) {
      target.querySelectorAll('.tp-global-notice').forEach(el => el.remove());
      const notice = document.createElement('p'); notice.className = 'tp-global-notice'; notice.textContent = message; notice.tabIndex = -1; notice.setAttribute('role', 'status'); target.prepend(notice);
      notice.focus({ preventScroll: true });
      if (target.closest('cart-drawer') && typeof trapFocus === 'function') trapFocus(target, notice);
    }
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
    schedule();
  }
  async function applyChange({ key, targetId, expected, source, openDrawer }) {
    if (busy) return;
    busy = true;
    const previous = [...document.querySelectorAll('cart-drawer button,cart-drawer input,cart-items button,cart-items input,product-form button,#main-cart-footer button')].map(control => [control, control.disabled]);
    previous.forEach(([control]) => { control.disabled = true; });
    const oldPending = pending.get(key); pending.delete(key);
    let cart, message = text.updated;
    const events = [], SDK = window.StandardEvents?.CartLinesUpdateEvent;
    try {
      const original = groupItems(domCart(), key);
      if (SDK && (original.length || targetId)) {
        const promise = SDK.createPromise(); events.push(promise);
        const action = !targetId ? 'remove' : original.length ? 'update' : 'add';
        const lines = original.length ? original.map(item => ({ id: item.key, quantity: variantId(item) === Number(targetId) ? 1 : 0 })) : [{ merchandiseId: String(targetId), quantity: 1 }];
        source.dispatchEvent(new SDK({ action, context: source.closest('product-info') ? 'product' : 'cart', lines, promise: promise.promise }));
      }
      cart = await replaceGroup({ api, key, targetId, expected });
      events.forEach(event => event.resolve({ cart: SDK.createCartFromAjaxResponse(cart) }));
    } catch (error) {
      events.forEach(event => event.reject(error));
      if (oldPending !== undefined) pending.set(key, oldPending);
      message = text[error.code] || text.error;
      try { cart = await api.cart(); } catch {}
    }
    try {
      await refresh(cart, message);
      if (openDrawer) document.querySelector('cart-drawer')?.open(source);
    } catch {
      const area = document.querySelector('cart-drawer.active .drawer__inner') || source.closest('product-info')?.querySelector('[data-total-feedback]') || source;
      const notice = document.createElement('p'); notice.className = 'tp-global-notice'; notice.setAttribute('role', 'alert'); notice.textContent = text.error;
      const link = document.createElement('a'); link.href = config.root + 'cart'; link.textContent = text.total_packs; notice.append(' ', link); area.prepend(notice);
    } finally {
      busy = false;
      source.removeAttribute('aria-busy');
      previous.forEach(([control, disabled]) => { if (control.isConnected) control.disabled = disabled; });
      schedule();
    }
  }
  if (!customElements.get('tf-total-packs')) customElements.define('tf-total-packs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return; this.initialized = true;
      this.key = JSON.stringify([String(this.dataset.productId), this.dataset.color, this.dataset.length]);
      this.count = pending.get(this.key) ?? Number(this.dataset.count);
      this.style.setProperty('--tp-cols', String(Math.max(1, cap + 1)));
      this.addEventListener('change', event => {
        event.stopPropagation();
        if (event.target.matches('input[type="radio"]')) {
          if (event.target.value === 'more') this.setMore(Math.max(cap + 1, this.count));
          else {
            const count = Number(event.target.value), choice = this.model?.choices.find(choice => choice.count === count);
            if (!choice?.available || !choice.id) return;
            this.querySelector('[data-tp-status]').textContent = text.updating;
            this.setAttribute('aria-busy', 'true');
            applyChange({ key: this.key, targetId: choice.id, expected: snapshot(groupItems(domCart(), this.key)), source: this });
          }
        } else if (event.target.matches('[data-tp-more-count]')) this.setMore(Number(event.target.value));
      });
      this.querySelector('[data-tp-remove]').addEventListener('click', () => applyChange({ key: this.key, targetId: 0, expected: snapshot(groupItems(domCart(), this.key)), source: this }));
      if (pending.has(this.key) || this.count > cap) this.setMore(this.count);
      this.load();
    }
    disconnectedCallback() { this.controller?.abort(); }
    setMore(count) {
      this.count = count; pending.set(this.key, count);
      const panel = this.querySelector('[data-tp-more]'); panel.hidden = false;
      this.querySelector('input[value="more"]').checked = true;
      const input = this.querySelector('[data-tp-more-count]'); if (input.value !== String(count)) input.value = count;
      const valid = validCount(count) && count > cap;
      input.setAttribute('aria-invalid', String(!valid));
      this.querySelector('[data-tp-price]').textContent = text.quote_price;
      this.querySelector('[data-tp-weight]').textContent = valid ? `${packText(count)} · ${count * Number(this.dataset.grams)}g` : '';
      this.querySelector('[data-tp-status]').textContent = valid ? text.noted : fmt('invalid', { min: cap + 1 });
      schedule();
    }
    async load() {
      this.controller = new AbortController();
      try {
        const url = new URL(this.dataset.productUrl, location.origin); url.searchParams.set('variant', this.dataset.variant); url.searchParams.set('section_id', 'tf-total-pack-options');
        const response = await fetch(url, { signal: this.controller.signal, cache: 'no-store' }); if (!response.ok) throw new Error('model_failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const model = JSON.parse(doc.querySelector('[data-tp-model]')?.textContent || 'null');
        if (!model || String(model.productId) !== this.dataset.productId || model.color !== this.dataset.color || model.length !== this.dataset.length) throw new Error('wrong_model');
        this.model = model;
        this.querySelectorAll('input[type="radio"]').forEach(input => {
          if (input.value === 'more') return;
          const choice = model.choices.find(choice => choice.count === Number(input.value));
          input.disabled = !choice?.available || !choice.id || choice.color !== model.color || choice.length !== model.length;
        });
        if (!pending.has(this.key)) this.querySelector('[data-tp-status]').textContent = '';
      } catch (error) { if (error.name !== 'AbortError') this.querySelector('[data-tp-status]').textContent = text.error; }
    }
  });
  document.addEventListener('click', async event => {
    if (busy && event.target.closest('cart-drawer,cart-items,#main-cart-footer,[data-total-product]')) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    const packInput = event.target.closest('.native-pack-grid input');
    if (packInput) { productState(packInput.closest('[data-total-product]')).more = false; schedule(); }
    const more = event.target.closest('[data-total-more]');
    if (more) { const info = more.closest('[data-total-product]'); productState(info).more = true; renderProduct(info); info.querySelector('[data-total-more-count]')?.focus(); return; }
    const quote = event.target.closest('[data-total-quote]');
    if (quote) {
      event.preventDefault();
      const info = quote.closest('[data-total-product]'); await productAction(info, true); return;
    }
    const checkout = event.target.closest('#CartDrawer-Checkout,button[name="checkout"][form="cart"],#checkout');
    if (checkout && route().quote) { event.preventDefault(); event.stopImmediatePropagation(); if (!route().invalid && !busy) location.href = quoteUrl(route().items); }
  }, true);
  document.addEventListener('change', event => {
    const info = event.target.closest('[data-total-product]'); if (!info) return;
    if (event.target.matches('.native-pack-grid input')) productState(info).more = false;
    schedule();
  }, true);
  document.addEventListener('input', event => { if (event.target.matches('[data-total-more-count]')) schedule(); });
  async function productAction(info, forceQuote = false) {
    const selected = selectedProduct(info), state = productState(info);
    const more = state.more || selected.item.count > cap || cap === 0;
    const count = more ? Number(info.querySelector('[data-total-more-count]')?.value) : selected.item.count;
    if (!validCount(count) || (more && count <= cap)) return;
    const item = { ...selected.item, count }, feedback = info.querySelector('[data-total-feedback]');
    if (!item.color || !item.length) return;
    let cart;
    try { cart = await api.cart(); } catch { feedback.textContent = text.cart_error; return; }
    const decision = route(cart, { key: selected.key, item });
    if (forceQuote || more || decision.quote) { location.href = quoteUrl(decision.items); return; }
    if (!selected.variant?.available || parseFloat(selected.variant.options[2]) !== count) { feedback.textContent = text.unavailable; return; }
    feedback.textContent = text.updating;
    await applyChange({ key: selected.key, targetId: selected.variant.id, expected: snapshot(groupItems(cart, selected.key)), source: info.productForm?.submitButton || info.querySelector('button[name="add"]'), openDrawer: true });
    feedback.textContent = '';
  }
  document.addEventListener('submit', event => {
    const info = event.target.closest('[data-total-product]');
    if (info && event.target.matches('form[data-type="add-to-cart-form"]')) { event.preventDefault(); event.stopImmediatePropagation(); if (!busy) productAction(info); return; }
    if (event.submitter?.name === 'checkout' && route().quote) { event.preventDefault(); event.stopImmediatePropagation(); if (!route().invalid && !busy) location.href = quoteUrl(route().items); }
  }, true);
  document.addEventListener('click', event => { if (busy && event.target.closest('cart-drawer,cart-items,#main-cart-footer,product-form')) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
  const observer = new MutationObserver(schedule); observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.variantChange, schedule);
  renderAll();
})();
